import React, { ReactNode } from 'react';

import { cn } from '@/src/util/ui';

type SidebarItemProps = {
  className?: string;
  paddingClasses?: string;
  marginClasses?: string;
  children: ReactNode;
};

const SidebarItem = ({ className, paddingClasses, marginClasses, children }: SidebarItemProps) => {
  return (
    <div
      className={cn(
        'container--actionItem',
        'tw-flex tw-items-center tw-justify-center',
        'tw-leading-none',
        className,
        paddingClasses ? paddingClasses : 'tw-py-[10px]',
        marginClasses ? marginClasses : 'tw-m-0'
      )}
    >
      {children}
    </div>
  );
};

export default SidebarItem;
